import React from 'react';

import * as Styled from './confetti-burst.style';

export type ConfettiBurstProps = {
  onDone: () => void;
};

const PARTICLE_COUNT = 12;
const DISTANCE = 20;

const particles = Array.from({ length: PARTICLE_COUNT }, (_, index) => {
  const angle = (360 / PARTICLE_COUNT) * index;
  const radians = (angle * Math.PI) / 180;
  const distance = DISTANCE * (0.7 + (index % 3) * 0.2);

  return {
    index,
    tx: Math.cos(radians) * distance,
    ty: Math.sin(radians) * distance,
    rot: angle + 90,
    color: Styled.CONFETTI_COLORS[index % Styled.CONFETTI_COLORS.length],
  };
});

export const ConfettiBurst: React.FC<ConfettiBurstProps> = ({ onDone }) => (
  <Styled.Container onAnimationEnd={onDone}>
    {particles.map((particle) => (
      <Styled.Particle
        key={particle.index}
        $tx={particle.tx}
        $ty={particle.ty}
        $rot={particle.rot}
        $color={particle.color}
      />
    ))}
  </Styled.Container>
);
